<script>
import { Pie, mixins } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
 
export default {
  extends: Pie,
  components: { ChartJsPluginDataLabels },
  props: ["chartData", "optionSet"],
  mixins: [mixins.reactiveProp],
  mounted () {
    this.$nextTick(function() {
      this.renderChart(this.chartData, this.optionSet)
    })
  }
}
</script>